module.exports = __webpack_public_path__ + "static/1339027651.32d600be.jpg";